import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/var/www/hotlot-staging/web/layouts/default.vue").then(m => m.default || m)),
  landing: defineAsyncComponent(() => import("/var/www/hotlot-staging/web/layouts/landing.vue").then(m => m.default || m)),
  profile: defineAsyncComponent(() => import("/var/www/hotlot-staging/web/layouts/profile.vue").then(m => m.default || m))
}